import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getcontentPageHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ ...action.payload }),
		);
		yield put({
			type: types.GET_CONTENT_PAGE_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CONTENT_PAGE_ERROR,
			payload,
		});
	}
}

export function* getcontentPageWatcherSaga() {
	yield takeLatest(types.GET_CONTENT_PAGE_START, getcontentPageHandlerSaga);
}

//create

//delete

function* deletecontentPageHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem(action.payload.path, action.payload.id),
		);
		yield put({
			type: types.DELETE_CONTENT_PAGE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CONTENT_PAGE_ERROR,
			payload,
		});
	}
}

export function* deletecontentPageWatcherSaga() {
	yield takeLatest(
		types.DELETE_CONTENT_PAGE_START,
		deletecontentPageHandlerSaga,
	);
}

//update
